import { useIntl } from 'react-intl';
import Picture from '../../../atoms/Picture';
import getImageProperties from '~/helpers/getImageProperties';
import ContentHubText from '../../../atoms/Icon/icons/ContentHubText';
import ContentHubAudio from '../../../atoms/Icon/icons/ContentHubAudio';
import ContentHubVideo from '../../../atoms/Icon/icons/ContentHubVideo';
import {
  ContentHubColorLine,
  ContentHubContent,
  ContentHubDescription,
  ContentHubHeadline,
  ContentHubImage,
  ContentHubTopic,
  ContentHubType,
  ContentHubTypeIcon,
  ContentHubTypeSeparator,
} from '../../../molecules/ContentHubTeaserCard/ContentHubTeaserCard.styles';
import {
  dataLayerEvents,
  dataLayerActions,
  pushEvent,
} from '~/helpers/datalayer';
import { ContentHubDynamicCard } from './ContentHubTeaserCardDynamic.styles';

/**
 * @param {string} mediaType
 * @returns {React.ReactElement}
 */
const getMediaTypeIcon = (mediaType) => {
  switch (mediaType) {
    case 'TEXT':
      return <ContentHubText />;
    case 'AUDIO':
      return <ContentHubAudio />;
    case 'VIDEO':
      return <ContentHubVideo />;
    default:
      return <ContentHubText />;
  }
};

/**
 * @param {ContentHubTeaserCardWrapperProps} props
 * @returns {React.ReactElement} The rendered component
 */
export default function ContentHubTeaserCardDynamic({
  withPicture = true,
  withDescription = true,
  format,
  description,
  image,
  mediaType,
  postType,
  isSelected = false,
  title,
  topic,
  onClick,
}) {
  const intl = useIntl();
  const imgUrls = getImageProperties(
    {
      xl: image?.format16to9?.url || '',
      md: image?.format4to3?.url || '',
      xs: image?.format4to3?.url || '',
    },
    'contentHubTeaser',
  );

  return (
    <ContentHubDynamicCard
      isSelected={isSelected}
      data-id="content-hub-card"
      onClick={() => {
        onClick();
        pushEvent({
          event: dataLayerEvents.CONTENT_HUB_TEASER_PREVIEW_CLICK,
          action: dataLayerActions.TEASER_CLICK,
          label: title,
          payload: topic,
        });
      }}
    >
      {withPicture && (
        <ContentHubImage>
          <Picture
            urls={
              format === 'landscape'
                ? {
                    xl: imgUrls.xl,
                    md: imgUrls.xl,
                    xs: imgUrls.xl,
                  }
                : {
                    xl: imgUrls.md,
                    md: imgUrls.md,
                    xs: imgUrls.md,
                  }
            }
          />
        </ContentHubImage>
      )}
      <ContentHubContent data-id="content-hub-card-content">
        <ContentHubHeadline
          data-id="content-hub-card-headline"
          lang={intl.locale}
        >
          {title}
        </ContentHubHeadline>
        <ContentHubColorLine data-id="content-hub-card-colorline" />
        {description && withDescription && (
          <ContentHubDescription data-id="content-hub-card-description">
            {description}
          </ContentHubDescription>
        )}
        <ContentHubTopic>
          <span>{topic}</span>
        </ContentHubTopic>
        <ContentHubType>
          <span>{postType}</span>
          <ContentHubTypeSeparator> | </ContentHubTypeSeparator>
          <ContentHubTypeIcon>{getMediaTypeIcon(mediaType)}</ContentHubTypeIcon>
        </ContentHubType>
      </ContentHubContent>
    </ContentHubDynamicCard>
  );
}
